import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './PaymentButton.scss';

function PaymentButton({ children, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames('ui-btn', 'ui-btn_primary', styles.root)}
    >
      {children}
    </button>
  );
}

PaymentButton.defaultProps = {
  children: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default PaymentButton;
